import styled from 'styled-components';
import {fontWeightSemiBold} from 'styles/fonts/fontWeights';
import {fontFamilyMono} from 'styles/fonts/fontFamilies';

export const Heading = styled.div`
  ${fontWeightSemiBold}
  ${fontFamilyMono}
  margin-bottom: 4px;
`;
